import Carousels from "./../components/Carousels";

export default class Lazyload {
    constructor() {
        this.instance = self;
    }

    static init() {
        const self = new Lazyload();
        self.attachEvents();
    }

    static watchNewElement(selector) {
        const self = new Lazyload();
        self.watchElement(selector);
    }

    attachEvents() {
        const self = this;

        self.watchElement("[data-lazy-img]");
        self.watchElement("[data-lazy-svg]");
        self.watchElement("[data-lazy-request]");

        $(document).on("keydown", function (e) {
            if (
                e.ctrlKey &&
                (e.key == "p" ||
                    e.charCode == 16 ||
                    e.charCode == 112 ||
                    e.keyCode == 80)
            ) {
                e.cancelBubble = true;
                e.preventDefault();
                e.stopImmediatePropagation();

                self.printPageLazy();
            }
        });

        window.site.lazyLoad = function (selector) {
            self.watchElement(selector);
        };

        window.site.printPageLazy = function () {
            self.printPageLazy();
        };
    }

    watchElement(selector) {
        const self = this;

        var elements = document.querySelectorAll(selector),
            config = {
                rootMargin: "50px 0px",
                threshold: 0.01,
            };

        if (!("IntersectionObserver" in window)) {
            var elementsArray = [];

            for (var i = 0; i < elements.length; i++) {
                elementsArray.push(elements[i]);
            }

            elementsArray.forEach(function (element) {
                self.preloadElement(element);
            });
        } else {
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    // Are we in viewport?
                    if (
                        entry.isIntersecting === true ||
                        entry.intersectionRatio > 0
                    ) {
                        // Stop watching and load the element
                        observer.unobserve(entry.target);
                        self.preloadElement(entry.target);
                    }
                });
            }, config);

            elements.forEach(function (element) {
                observer.observe(element);
            });
        }
    }

    printPageLazy() {
        const self = this;

        oc.progressBar.show();

        var images = document.querySelectorAll("[data-lazy-img]"),
            imagesArray = [];

        for (var i = 0; i < images.length; i++) {
            imagesArray.push(images[i]);
        }

        imagesArray.forEach(function (image) {
            self.preloadImage(image);
        });

        setTimeout(function () {
            $("body").imagesLoaded({ background: true }, function () {
                oc.progressBar.hide();
                window.print();
            });
        }, 100);
    }

    preloadElement(element) {
        const self = this;

        if (element.hasAttribute("data-lazy-img")) {
            self.preloadImage(element);
        } else if (element.hasAttribute("data-lazy-svg")) {
            self.preloadSvg(element);
        } else if (element.hasAttribute("data-lazy-request")) {
            self.preloadOcRequest(element);
        }
    }

    preloadImage(image) {
        var elementName = image.tagName.toLowerCase(),
            imgSrc = image.getAttribute("data-lazy-img");

        if (elementName == "img") {
            image.src = imgSrc;
        } else {
            image.style.backgroundImage = "url(" + imgSrc + ")";
        }
    }

    preloadSvg(svg) {
        var svgFile = svg.getAttribute("data-lazy-svg"),
            url = window.site.themeDir + "/assets/svgs/" + svgFile + ".svg";

        var ajax = new XMLHttpRequest();
        ajax.open("GET", url, true);
        ajax.send();

        ajax.onload = function (e) {
            svg.innerHTML = ajax.responseText;
        };
    }

    preloadOcRequest(element) {
        const self = this;

        var request = element.getAttribute("data-lazy-request"),
            data = element.getAttribute("data-request-data")
                ? JSON.parse(element.getAttribute("data-request-data"))
                : {},
            update = JSON.parse(element.getAttribute("data-request-update")),
            successScript = element.getAttribute("data-lazy-success-script");

        $.request(request, {
            data: data,
            update: update,
            success: function (data, textStatus, jqXHR) {
                this.success(data, textStatus, jqXHR);

                $.each(update, function (partial, el) {
                    $('[data-toggle="tooltip"]').tooltip();

                    if ($(el + " .js-styled-select").length > 0) {
                        Carousels.initCarousel($(el + " .js-styled-select"));
                    }

                    if ($(el + " [data-lazy-img]").length > 0) {
                        self.watchElement("[data-lazy-img]");
                    }

                    if ($(el + " [data-lazy-svg]").length > 0) {
                        self.watchElement("[data-lazy-svg]");
                    }

                    if (successScript) {
                        eval(successScript);
                    }
                });
            },
        });
    }
}
